import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import apiConstants from 'shared/api/apiConstants';
import { getRealmLocally } from '~/shared/keycloak/keycloak.service.js';

class AppStore {
  isLoading = true;
  isAccountLoading = true;
  isAdminStoreDataReq = true;
  isPpApplied = false;
  isCustomerPricingMode = false;
  isChangeAccountLoading = false;

  constructor(rootStore, apiGateway) {
    this.rootStore = rootStore;
    this.apiGateway = apiGateway;
    makeObservable(this, {
      isLoading: observable,
      isAccountLoading: observable,
      isChangeAccountLoading: observable,
      isPpApplied: observable,
      isKeyCloakManagement: computed,
      isCustomerPricingMode: observable,
      setIsAccountLoading: action,
      setIsChangeAccountLoading: action,
      updatePricingMode: action,
    });
  }

  get isKeyCloakManagement() {
    return !!getRealmLocally();
  }

  updateMarginIfOfTypeReseller = () => {
    const { usersStore } = this.rootStore;
    const user = usersStore && usersStore.getUserByKey(usersStore.currentDisplayedUserKey);
    if (!user) {
      return;
    }
    if (!usersStore.isCurrentUserReseller && !usersStore.isCurrentUserReCustomer) {
      this.updatePricingMode(false);
    } else {
      const isCustomerPricingMode = !!JSON.parse(
        window.localStorage.getItem('isPpApplied') ?? this.isCustomerPricingMode,
      );
      this.updatePricingMode(isCustomerPricingMode);
    }
  };

  getIsPpApplied = (usersStore) => {
    if (usersStore.isCurrentUserReseller) {
      return this.isCustomerPricingMode;
    }
    return usersStore.isCurrentUserReCustomer;
  };

  updateMargin = () => {
    const { queryClient } = this.rootStore;
    const isPpApplied = this.getIsPpApplied(this.rootStore.usersStore);
    const oldPpApplied = this.isPpApplied;
    this.isPpApplied = isPpApplied;
    if (queryClient && oldPpApplied !== isPpApplied) {
      queryClient.invalidateQueries({ queryKey: [apiConstants.QUERY_KEYS.PRICING_MODE_CHANGED] });
      window.localStorage.setItem('isPpApplied', isPpApplied);
    }
  };

  updatePricingMode = (isCustomerPricingMode = true) => {
    this.isCustomerPricingMode = isCustomerPricingMode;
    const cloudAccountType = this.rootStore.usersStore.currDispUserCloudAccountType;
    this.updateMargin(cloudAccountType);
  };

  getCommonParams = () => {
    this.updateMarginIfOfTypeReseller();
    return { isPpApplied: this.isPpApplied };
  };

  fetchData = async () => {
    try {
      runInAction(() => {
        this.isLoading = false;
        this.isAdminStoreDataReq = false;
      });
    } catch {
      this.state = 'error';
    }
  };

  setIsAccountLoading = (isAccountLoading) => {
    this.isAccountLoading = isAccountLoading;
  };
  setIsChangeAccountLoading = (isChangeAccountLoading) => {
    this.isChangeAccountLoading = isChangeAccountLoading;
  };

  invalidateStore = () => {
    this.isLoading = true;
    this.isAdminStoreDataReq = true;
    this.isCustomerPricingMode = false;
    this.isPpApplied = false;
  };
}

export default AppStore;
